import Cookie from "js-cookie";
import { v4 as uuidv4 } from "uuid";
const qs = require("qs");

function isValidSessionId(id) {
  return id.match(
    /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/
  );
}

export default function ($vue) {
  var cart_id = "";

  const params = qs.parse(location.search, { ignoreQueryPrefix: true });

  // attempt to grab from url
  if (
    params["__dpd_cart"] !== undefined &&
    isValidSessionId(params.__dpd_cart)
  ) {
    cart_id = params.__dpd_cart;
  } else if (
    localStorage &&
    localStorage.cartId &&
    isValidSessionId(localStorage.cartId)
  ) {
    // grab from localStorage
    cart_id = localStorage.cartId;
  } else if (
    // attempt to grab from cookie
    Cookie.get("__dpd_cart") &&
    isValidSessionId(Cookie.get("__dpd_cart"))
  ) {
    cart_id = Cookie.get("__dpd_cart");
  } else if (!isValidSessionId(cart_id) && !$vue.$store.state.cartId) {
    // make one up!
    cart_id = uuidv4();
  }

  if (localStorage) {
    localStorage.cartId = cart_id;
  }
  Cookie.set("__dpd_cart", cart_id);
  $vue.$store.commit("setCartId", cart_id);
}
